<template>
  <div class="mypage-blocked-user-list-page" v-if="isIncludeNextRelease">
    <div class="mypage-blocked-user-list-page__header">
      <sub-header-section
        :pageTitle="$tc('MypagePage.MypageBlockedUserListPage.pageTitle')"
        backLink="/mypage"
      />
    </div>

    <div class="mypage-blocked-user-list-page__body">
      <mypage-blocked-user-list-pane />
    </div>

    <div class="mypage-blocked-user-list-page__footer">
      <global-navigation-pane current="mypage" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'
import MypageBlockedUserListPane from '@/components/MypageBlockedUserListPage/MypageBlockedUserListPane.vue'

export default defineComponent({
  name: 'MypageBlockedUserListPage',
  components: { MypageBlockedUserListPane, GlobalNavigationPane, SubHeaderSection },
  setup() {
    // TODO: ブロックしたユーザー一覧対応時に消す
    const isIncludeNextRelease = process.env.VUE_APP_INCLUDE_NEXT_RELEASE === 'true'
    return {
      isIncludeNextRelease,
    }
  },
})
</script>

<style scoped lang="scss">
.mypage-blocked-user-list-page {
  display: flex;
  flex-direction: column;
  height: calc(var(--screen-height) - 48px);
  padding-bottom: env(safe-area-inset-bottom);
  overflow: hidden;

  &__header {
    flex-shrink: 0;
  }

  &__body {
    flex-grow: 1;
    overflow-y: auto;
  }

  &__footer {
    flex-shrink: 0;
  }
}
</style>
